import React, { useCallback, useEffect, useRef, useState } from "react";
import userHitSound from "../../../Assets/final new sound/correct-2-46134.mp3";
import computerHitSound from "../../../Assets/new pinpong sound/comScore.mp3.mp3";
import moment from "moment";
import { useNavigate } from "react-router";
import { server_url } from "../../../Config/API";
import AuthUser from "../../../Hooks/authUser";
import PostHooks from "../../../Hooks/PostHooks";
import UpdateHooks from "../../../Hooks/UpdateHooks";
import GameStatsIndicator from "../GameStatsIndicator";

const PingPong = () => {
  const [timeLeft, setTimeLeft] = useState(300);
  const [score, setScore] = useState(0);
  const [pingPongData, setPingPongData] = useState([]);

  const userHitAudioRef = useRef(null);
  const computerHitAudioRef = useRef(null);
  if (typeof window !== "undefined") {
    if (!userHitAudioRef.current) userHitAudioRef.current = new Audio(userHitSound);
    if (!computerHitAudioRef.current) computerHitAudioRef.current = new Audio(computerHitSound);
  }

  const { userInfo } = AuthUser();
  const date = useRef(moment().format("YYYY-MM-D")).current;
  const time = useRef(moment().format("h:mm a")).current;

  const previousStateRef = useRef(null);
  const scoreRef = useRef(score);
  const timeRef = useRef(timeLeft);
  const isUpdating = useRef(false);

  scoreRef.current = score;
  timeRef.current = timeLeft;

  const navigate = useNavigate();
  const [isFullScreen, setIsFullScreen] = useState(false);

  const fetchFunction = async () => {
    try {
      const response = await fetch(
        `${server_url}/pingPong/specific?fieldName=userId&fieldValue=${
          userInfo?._id
        }&fieldName2=date&fieldValue2=${date}&fieldName3=gameName&fieldValue3=PingPong+Monocular`
      );
      const data = await response.json();
      setPingPongData(data?.data || []);
      if (data?.data && data?.data.length) {
        setScore(data?.data[0]?.score);
        previousStateRef.current = data?.data;
      }
    } catch (error) {
      console.error("Error fetching ping pong data:", error);
    }
  };

  useEffect(() => {
    if (pingPongData?.length) {
      setTimeLeft(pingPongData[0]?.remainingTime);
      setScore(pingPongData[0]?.score);
    }
  }, [pingPongData]);

  useEffect(() => {
    fetchFunction();
  }, []);

  const insertFunction = useCallback(() => {
    if (previousStateRef?.current?.length) {
      UpdateHooks(
        `${server_url}/pingPong/updatePingPong/${previousStateRef?.current[0]?._id}`,
        {
          date,
          time,
          score: scoreRef.current,
          remainingTime: timeRef.current,
        }
      );
    } else {
      PostHooks(
        `${server_url}/pingPong/addPingPong`,
        {
          gameName: "PingPong Monocular",
          userId: userInfo?._id,
          userName: userInfo?.name,
          date,
          time,
          score: scoreRef.current,
          remainingTime: timeRef.current,
        },
        "pin pong score updated !"
      );
    }
  }, [userInfo, date, time]);

  const insertFunctionRef = useRef(insertFunction);
  useEffect(() => {
    insertFunctionRef.current = insertFunction;
  }, [insertFunction]);

  const toggleFullScreenRef = useRef(null);
  const toggleFullScreen = () => {
    if (!isFullScreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen().catch((error) => {
          console.error("Error entering full screen:", error);
        });
      }
    }
    setIsFullScreen(!isFullScreen);
  };
  toggleFullScreenRef.current = toggleFullScreen;

  useEffect(() => {
    toggleFullScreen();

    const canvas = document.getElementById("pong");
    const ctx = canvas.getContext("2d");

    function adjustCanvasDimensions() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }

    adjustCanvasDimensions();
    window.addEventListener("resize", adjustCanvasDimensions);

    const ball = {
      x: canvas.width / 2,
      y: canvas.height / 2,
      radius: 17,
      velocityX: 5,
      velocityY: 5,
      speed: 7,
      color: "WHITE",
    };

    const user = {
      x: 0,
      y: (canvas.height - 100) / 2,
      width: 10,
      height: 100,
      score: 0,
      color: "WHITE",
    };

    const com = {
      x: canvas.width - 10,
      y: (canvas.height - 100) / 2,
      width: 10,
      height: 100,
      score: 0,
      color: "WHITE",
    };

    function drawRect(x, y, w, h, color) {
      ctx.fillStyle = color;
      ctx.fillRect(x, y, w, h);
    }

    function drawArc(x, y, r, color) {
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(x, y, r, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
    }

    function getMousePos(evt) {
      let rect = canvas.getBoundingClientRect();
      user.y = evt.clientY - rect.top - user.height / 2;
    }
    canvas.addEventListener("mousemove", getMousePos);

    function resetBall() {
      ball.x = canvas.width / 2;
      ball.y = canvas.height / 2;
      ball.velocityX = -ball.velocityX;
      ball.speed = 7;
    }

    const countScore = () => {
      if (!isUpdating.current) {
        isUpdating.current = true;
        setScore((prevScore) => prevScore + 1);
        setTimeout(() => {
          isUpdating.current = false;
        }, 0);
      }
    };

    function collision(b, p) {
      p.top = p.y;
      p.bottom = p.y + p.height;
      p.left = p.x;
      p.right = p.x + p.width;

      b.top = b.y - b.radius;
      b.bottom = b.y + b.radius;
      b.left = b.x - b.radius;
      b.right = b.x + b.radius;

      const collide =
        p.left < b.right &&
        p.top < b.bottom &&
        p.right > b.left &&
        p.bottom > b.top;

      if (collide) {
        if (p === user) {
          countScore();
          if (userHitAudioRef.current) {
            userHitAudioRef.current.currentTime = 0;
            userHitAudioRef.current.play().catch(e => console.log(e));
          }
        }
      }
      return collide;
    }

    function update() {
      if (ball.x - ball.radius < 0) {
        com.score++;
        resetBall();
      } else if (ball.x + ball.radius > canvas.width) {
        user.score++;
        resetBall();
      }

      ball.x += ball.velocityX;
      ball.y += ball.velocityY;

      com.y += (ball.y - (com.y + com.height / 2)) * 0.1;

      if (ball.y - ball.radius < 0 || ball.y + ball.radius > canvas.height) {
        ball.velocityY = -ball.velocityY;
      }

      let player = ball.x + ball.radius < canvas.width / 2 ? user : com;
      let playerHit = collision(ball, player);

      if (playerHit) {
        let collidePoint = ball.y - (player.y + player.height / 2);
        collidePoint = collidePoint / (player.height / 2);
        let angleRad = (Math.PI / 4) * collidePoint;

        let direction = ball.x + ball.radius < canvas.width / 2 ? 1 : -1;
        ball.velocityX = direction * ball.speed * Math.cos(angleRad);
        ball.velocityY = ball.speed * Math.sin(angleRad);
        ball.speed += 0.1;
      }
    }

    function render() {
      drawRect(0, 0, canvas.width, canvas.height, "#000");
      drawRect(user.x, user.y, user.width, user.height, user.color);
      drawRect(com.x, com.y, com.width, com.height, com.color);
      drawArc(ball.x, ball.y, ball.radius, ball.color);
    }

    function game() {
      update();
      render();
    }

    const framePerSecond = 100;
    const loop = setInterval(game, 1000 / framePerSecond);

    return () => {
      clearInterval(loop);
      window.removeEventListener("resize", adjustCanvasDimensions);
      canvas.removeEventListener("mousemove", getMousePos);
    };
  }, []);

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(countdownInterval);
          insertFunctionRef.current();
          navigate(-1);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, [navigate]);

  useEffect(() => {
    const handleKeyPress = async (event) => {
      if (event.keyCode === 27 && isFullScreen) {
        insertFunctionRef.current();
        await navigate(-1);
        if (toggleFullScreenRef.current) toggleFullScreenRef.current();
      }
    };

    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [isFullScreen, navigate]);

  const min = Math.floor(timeLeft / 60);
  return (
    <div className="fixed inset-0 bg-white">
      <GameStatsIndicator score={score} timeLeft={timeLeft} />
      <canvas id="pong"></canvas>
    </div>
  );
};

export default PingPong;
